module.exports = __webpack_public_path__ + "img/featured-mobile-cta-1.29c8fb70.jpg";